import React, {useEffect} from "react";
import {Col, Row} from "react-bootstrap";
import TextArea from "../../../common/TextArea";
import Input from "../../../common/Input";
import DateBox from "../../../primer/DateBox";
import {useDispatch, useSelector} from "react-redux";
import {setSaveNewPOS} from "../../../../_reducers/activitySlice";
import Checkbox from "../../../common/CheckBox";
import {setNewPOS} from "../../../../_reducers/DataPanel/Cash/cashSlice";
import BetterCheckBox from "../../../common/BetterCheckBox";
import {
    checkPermission,
    getAcquirerPOSOptions,
    isEmpty,
} from "../../../../_helpers/commonFunctions";
import {fetchCashSettings} from "../../../../_apis/api";
import Dropdown from "../../../primer/Dropdown";
import {useTranslation} from "../../../../hooks/useTranslation";

const PosNew = () => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const saveNewPOS = useSelector((state) => state.ACTIVITY.saveNewPOS);
    const cashSettings = useSelector((state) => state.CASH_DATA.cashSettings);
    const newPOS = useSelector((state) => state.CASH_DATA.newPOS);
    const company = useSelector((state) => state.COMPANY_DATA.company);
    const permissionsData = JSON.parse(localStorage.getItem("user"))?.permissions;

    useEffect(() => {
        dispatch(fetchCashSettings(company.id));
    }, [])

    useEffect(() => {
        if (!isEmpty(cashSettings?.accounting?.accountingPOS) && isEmpty(newPOS.name)) {
            dispatch(setNewPOS({...newPOS, accounting: cashSettings.accounting.accountingPOS}))
        }
    }, [cashSettings.accounting])

    const handleOnChange = (e, type = "default", ddname = '') => {
        if (!saveNewPOS) dispatch(setSaveNewPOS(true));

        let posData = structuredClone(newPOS);

        let name;
        let value;
        if (type === 'dp') {
            value = e;
            name = ddname;
        } else if (type === "dd") {
            value = e.value;
            name = ddname;
        } else {
            value = e.target.value;
            name = e.target.name;
            if (name === "isETameiaki") {
                posData["isWebECR"] = "false";
                value = e.target.checked === true ? "active" : "inactive";
                posData[name] = value;
                if (!getAcquirerPOSOptions(posData).find((el) => el.value === posData.acquirer)) posData["acquirer"] = "";
            } else if (name === "isWebECR") {
                posData["isETameiaki"] = "inactive";
                value = e.target.checked === true ? "true" : "false";
                posData[name] = value;
                if (!getAcquirerPOSOptions(posData).find((el) => el.value === posData.acquirer)) posData["acquirer"] = "";
            }
        }
        posData[name] = value;
        dispatch(setNewPOS(posData));
    }

    return (
        <React.Fragment>
            <Row className="position-relative border-bottom mb-3">
                <Col xs="12" md="12" className="d-flex align-items-center justify-content-end ">
                    <div className="inline-field d-flex align-items-center acremd  mb-3">
                        <label htmlFor="product-active" className="mb-0 mr-2 ">{t('PosNew.active')}</label>
                        <Checkbox
                            className="mb-2"
                            name="isActive"
                            key={Math.random()}
                            id="product-active"
                            defaultValue={newPOS.isActive}
                            value={newPOS.isActive === 'active' ? "inactive" : "active"}
                            onChange={(e) => handleOnChange(e)}
                        />
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={4}>
                    <Input
                        className="w-100"
                        label={t('PosNew.name.name')}
                        name="name"
                        placeholder={t('PosNew.name.placeholder')}
                        value={newPOS.name}
                        required={true}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewPOS && newPOS.name === '' &&
                        <div className="text-danger">{t('PosNew.name.required')}</div>}
                </Col>
                {(newPOS.isETameiaki !== "active" && newPOS.isWebECR !== "true") && (
                    <Col md={4}>
                        <Dropdown
                            className={"mb-0"}
                            name={"acquirer"}
                            label={"Πάροχος Πληρωμών"}
                            required={true}
                            key={Math.random()}
                            defaultValue={getAcquirerPOSOptions(newPOS).find((el) => el.value === newPOS.acquirer)}
                            options={getAcquirerPOSOptions(newPOS)}
                            onChange={(e) => handleOnChange(e, "dd", "acquirer")}
                        />
                        {saveNewPOS && isEmpty(newPOS.acquirer) &&
                            <div className="text-danger">Απαιτείται ο πάροχος πληρωμών.</div>}
                    </Col>
                )}
            </Row>
            <Row>
                <Col sm="12" md="3">
                    <BetterCheckBox
                        name={"isETameiaki"}
                        text={t("PosNew.isETameiaki")}
                        className="pt-2"
                        checked={newPOS.isETameiaki === "active"}
                        onChange={(e) => handleOnChange(e, "cb")}
                    />
                </Col>
            </Row>
            {newPOS.isETameiaki === "active" && (
                <div style={{border: "2px solid lightgray", borderRadius: "8px", padding: "10px"}} className={"mb-2"}>
                    <Row className="mb-3">
                        <Col sm="12" md="3">
                            <Input
                                name="tameiakiUsername"
                                label={t("PosNew.tameiakiUsername.label")}
                                placeholder={t("PosNew.tameiakiUsername.placeholder")}
                                required={true}
                                autoComplete={"off"}
                                value={newPOS.tameiakiUsername}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveNewPOS && String(newPOS.tameiakiUsername).trim() === "" && (
                                <div className="text-danger">{t("PosNew.tameiakiUsername.required")}</div>)}
                        </Col>
                        <Col sm="12" md="3">
                            <Input
                                name="tameiakiPassword"
                                label={t("PosNew.tameiakiPassword.label")}
                                placeholder={t("PosNew.tameiakiPassword.placeholder")}
                                required={true}
                                autoComplete={"off"}
                                value={newPOS.tameiakiPassword}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveNewPOS && String(newPOS.tameiakiPassword).trim() === "" && (
                                <div className="text-danger">{t("PosNew.tameiakiPassword.required")}</div>)}
                        </Col>
                        <Col sm="12" md="3">
                            <Input
                                name="tid"
                                label={"TID"}
                                placeholder={"TID"}
                                required={true}
                                autoComplete={"off"}
                                value={newPOS.tid}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveNewPOS && String(newPOS.tid).trim() === "" && (
                                <div className="text-danger">{t("PosNew.tid.required")}</div>)}
                        </Col>
                        <Col md={3}>
                            <Dropdown
                                className={"mb-0"}
                                name={"acquirer"}
                                label={"Πάροχος Πληρωμών"}
                                required={true}
                                key={Math.random()}
                                defaultValue={getAcquirerPOSOptions(newPOS).find((el) => el.value === newPOS.acquirer)}
                                options={getAcquirerPOSOptions(newPOS)}
                                onChange={(e) => handleOnChange(e, "dd", "acquirer")}
                            />
                            {saveNewPOS && isEmpty(newPOS.acquirer) &&
                                <div className="text-danger">Απαιτείται ο πάροχος πληρωμών.</div>}
                        </Col>
                    </Row>
                </div>
            )}
            <Row>
                <Col sm="12" md="3">
                    <BetterCheckBox
                        name={"isWebECR"}
                        text={"Διασύνδεση με Web ECR"}
                        className="pt-2"
                        checked={newPOS.isWebECR === "true"}
                        onChange={(e) => handleOnChange(e, "cb")}
                    />
                </Col>
            </Row>
            {newPOS.isWebECR === "true" && (
                <div style={{border: "2px solid lightgray", borderRadius: "8px", padding: "10px"}} className={"mb-2"}>
                    <Row>
                        <Col md={3}>
                            <Input
                                name="webECR_ecrCode"
                                label={"Κωδικός ECR (ECR code)"}
                                required={true}
                                autoComplete={"off"}
                                value={newPOS.webECR_ecrCode}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveNewPOS && isEmpty(newPOS.webECR_ecrCode) && (
                                <div className="text-danger">Απαιτείται κωδικός ECR.</div>)}
                        </Col>
                        <Col md={3}>
                            <Input
                                name="webECR_tid"
                                label={"TID"}
                                required={true}
                                autoComplete={"off"}
                                value={newPOS.webECR_tid}
                                onChange={(e) => handleOnChange(e)}
                            />
                            {saveNewPOS && isEmpty(newPOS.webECR_tid) && (
                                <div className="text-danger">Απαιτείται TID.</div>)}
                        </Col>
                        <Col md={3}>
                            <Dropdown
                                className={"mb-0"}
                                name={"acquirer"}
                                label={"Πάροχος Πληρωμών"}
                                required={true}
                                key={Math.random()}
                                defaultValue={getAcquirerPOSOptions(newPOS).find((el) => el.value === newPOS.acquirer)}
                                options={getAcquirerPOSOptions(newPOS)}
                                onChange={(e) => handleOnChange(e, "dd", "acquirer")}
                            />
                            {saveNewPOS && isEmpty(newPOS.acquirer) &&
                                <div className="text-danger">Απαιτείται ο πάροχος πληρωμών.</div>}
                        </Col>
                    </Row>
                </div>
            )}
            <Row>
                <Col md={4}>
                    <div className="mb-3">
                        <DateBox
                            classes="w-100"
                            label={t('PosNew.date.date')}
                            name="date"
                            required={true}
                            selected="today"
                            allowOtherYears={true}
                            onChange={(e) => handleOnChange(e, 'dp', 'date')}
                        />
                        {saveNewPOS && isEmpty(newPOS.date) &&
                            <div className="text-danger">{t('PosNew.date.required')}</div>}
                    </div>
                </Col>
                <Col md={4}>
                    <Input
                        className="w-100"
                        label={t('PosNew.serialNumber.serialNumber')}
                        name="serialNumber"
                        placeholder={t('PosNew.serialNumber.placeholder')}
                        value={newPOS.serialNumber}
                        required={true}
                        autoComplete={"off"}
                        onChange={(e) => handleOnChange(e)}
                    />
                    {saveNewPOS && newPOS.serialNumber === '' &&
                        <div className="text-danger">{t('PosNew.serialNumber.required')}</div>}
                </Col>
            </Row>
            <hr className="mb-4"/>
            <Row>
                <div style={{width: "100%"}}>
                    <div className="text-muted mb-2"><i>{t('PosNew.notes')}</i></div>
                    <TextArea
                        rows="4"
                        placeholder={t('PosNew.addNotes')}
                        name="notes"
                        limit="1000"
                        value={newPOS.notes}
                        onChange={(e) => handleOnChange(e)}
                    />
                </div>
            </Row>
            {checkPermission("accounting-settings/accounting-read", permissionsData) === true && (
                <React.Fragment>
                    <hr/>
                    <div className="text-muted mb-2"><i>Λογιστική</i></div>
                    <Row className={"mb-2"}>
                        <Col md={4}>
                            <Input
                                name={"accounting"}
                                label={"Πρόθεμα Κωδικού Λογαριασμού"}
                                value={newPOS?.accounting}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                        <Col md={4}>
                            <Input
                                name={"bypassAccounting"}
                                label={"Κωδικός Λογαριασμού Παράκαμψης Λογιστικής Γέφυρας"}
                                value={newPOS?.bypassAccounting}
                                autoComplete={"off"}
                                onChange={(e) => handleOnChange(e)}
                            />
                        </Col>
                    </Row>
                </React.Fragment>
            )}
        </React.Fragment>
    )
}

export default PosNew;
